import { t } from 'i18next';
import z from 'zod';

export const updateAccountFormSchema = z.object({
  name: z.string().trim().nonempty(t('errors:forms.string.non_empty')),
  email: z
    .string()
    .trim()
    .nonempty(t('errors:forms.string.non_empty'))
    .pipe(z.email(t('errors:forms.string.email'))),
});

export type AccountSettingsUpdateInformationFormValues = z.input<typeof updateAccountFormSchema>;
